export default "__VITE_ASSET__CUdx4Acf__"